import { ProjectBoundary } from "../types/project";

export const bboxFromBoundary = (
  boundary: ProjectBoundary | null | undefined
): { top: number; left: number; bottom: number; right: number } | null => {
  if (!boundary) return null;
  const ring =
    boundary.type === "Polygon"
      ? (boundary.coordinates as number[][][])[0]
      : (boundary.coordinates as number[][][][])[0][0];
  const lngs = ring.map((c) => c[0]);
  const lats = ring.map((c) => c[1]);
  return {
    left: Math.min(...lngs),
    right: Math.max(...lngs),
    bottom: Math.min(...lats),
    top: Math.max(...lats),
  };
};
